// Organization + WebSite JSON-LD for the current site, on every page.
// Takes the site ref because app.vue, which provides it, can't inject it.
export const useSiteSchema = (currentSite) => {
  const origin = publicSiteOrigin(useRequestURL().href)

  const schema = computed(() => {
    const site = currentSite.value
    if (!site) return null

    return buildSiteGraphSchema({
      origin,
      site,
      logoPath: `/images/sites/${site.slug}/logo.png`,
    })
  })

  useHead({
    script: computed(() =>
      schema.value
        ? [
            {
              key: "schema-site",
              type: "application/ld+json",
              innerHTML: serializeJsonLd(schema.value),
            },
          ]
        : [],
    ),
  })
}
